export default "__VITE_ASSET__Dueh4eGJ__"